'use strict';
var toLength = require('../internals/to-length');

/**
 * 获取类数组长度
 * @param {any} obj 类数组
 * @returns {number}
 */
module.exports = function(obj) {
  return toLength(obj.length);
};
